

<!--<div mat-dialog-title class="_pay-dialog-title">
	<button mat-icon-button color="accent" mat-dialog-close cdkFocusInitial>
		<mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
	</button>
	<span class="_cap">{{'EX_PAYMENT_MODAL' | translate}}</span>
	<button mat-icon-button mat-dialog-close cdkFocusInitial>
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>-->

<div class="module-bar-fixed" style="position: relative; ">
	<button mat-icon-button color="accent" mat-dialog-close cdkFocusInitial>
		<mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
	</button>

	<span class="title text-truncate">
		<div>{{title | translate}}</div>
	</span>
	<button mat-icon-button color="accent" mat-dialog-close cdkFocusInitial>
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>

<div mat-dialog-content>
	<block-ui>
		<iframe id="add_payment" name="add_payment" frameborder="0" scrolling="no"
				class="embed-responsive-item panel"
				(load)="onFrameLoaded($event)"
				src="/assets/adyen/embed.html"></iframe>
	</block-ui>
</div>

